export enum MonetizableEnum {
  yesAssumed = 'yes_assumed',
  no = 'no',
  noBecauseOfDetails = 'no_because_of_details',
  noBecauseOfLead = 'no_because_of_lead',
  noBecauseOfLeadForm = 'no_because_of_lead_form',
  noBecauseOfLimit = 'no_because_of_limit',
}

export enum LinkType {
  APPLY_LINK = 'APPLY_LINK',
  APPLY_NOW_BUTTON = 'APPLY_NOW_BUTTON',
  INSTITUTION_IMAGE = 'INSTITUTION_IMAGE',
  OFFER_LINK = 'OFFER_LINK',
  OFFER_NAME = 'OFFER_NAME',
  PRODUCT_IMAGE = 'PRODUCT_IMAGE',
  PRODUCT_NAME = 'PRODUCT_NAME',
  REST_OF_PRODUCT_CARD = 'rest_of_product_card',
}
